var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BackButton'),_vm._l((_vm.data),function(i,index){return _c('VideoPage',{key:index,attrs:{"data":i}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }